import { Suspense, lazy } from 'react';

const PositionDetails = lazy(() => import('../components/Positions/PositionDetails'));

const PositionDetailsLazy: React.FC = () => {
    return <Suspense><PositionDetails/></Suspense>;
}

export default PositionDetailsLazy;
